module.exports = __webpack_public_path__ + "static/icons/icon-heart--red-a862d5c10c19bffbf64fbb97d3942470.svg";